module.exports = __webpack_public_path__ + "static/img/loading.cd38becc.gif";